import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface EmailsState {
    emails: any[];
}

const initialState: EmailsState = {
    emails: [],
};

const emailsSlice = createSlice({
    name: 'emails',
    initialState,
    reducers: {
        setEmailCount(state, action: PayloadAction<any[]>) {
            state.emails = action.payload;
        },
        updateEmailStatus(
            state,
            action: PayloadAction<{ id: string; status: string }>
        ) {
            const { id, status } = action.payload;
            const email = state.emails.find(e => e.id === id);
            if (email) {
                email.status = status;
            }
        },
    },
});

export const { setEmailCount, updateEmailStatus } = emailsSlice.actions;
export default emailsSlice.reducer;

// Selector to retrieve the emails array
export const selectEmailsCount = (state: any) => state.emails.emails;
